import { apiGet, apiPost } from './api';

export const getMemberships = async () => {
    const response = await apiGet('/api/v1/memberships/');
    const data = await response.json();
    return data.results;
};

export const getCurrentMemberships = async () => {
    const response = await apiGet('/api/v1/profile_memberships/');
    return response.json();
};

export const cancelFreeMembership = async (id) =>
    apiPost(`/api/v1/profile_memberships/${id}/cancel/`);

export const createSetupIntent = async (email) => {
    const response = await apiPost('/api/v1/payments/create-setup-intent', { email });
    return response.json();
};

export const createSubscription = async (paymentMethodId, productId, email) => {
    const response = await apiPost('/api/v1/payments/create-subscription', {
        paymentMethodId,
        productId,
        email,
    });
    return response.json();
};

export const cancelSubscription = async (subscriptionId) => {
    const response = await apiPost('/api/v1/payments/cancel-subscription', { subscriptionId });
    return response.json();
};

export const reactivateSubscription = async (subscriptionId) => {
    const response = await apiPost('/api/v1/payments/reactivate-subscription', { subscriptionId });
    return response.json();
};
